<template>
  <v-navigation-drawer app clipped>
    <v-list>
      <v-list-item :to="CLIENTS_ROUTE">
        <v-list-item-icon>
          <v-icon>mdi-laptop</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Clients</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="USERS_ROUTE">
        <v-list-item-icon>
          <v-icon>mdi-account</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Users</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import * as RouteNames from "../../router/routeNames";

export default {
  data: () => ({}),
  created() {
    this.USERS_ROUTE = RouteNames.Users;
    this.CLIENTS_ROUTE = RouteNames.Clients;
  }
};
</script>
